import $ from 'jquery';
import wishlist from 'modules/wishlist';
import '../../modules/plp-lazy-load';
import './size-selection';
import initColorSwatches from './plpswatches';
import { renderPlpSocialProof } from '../../modules/social-proof';
import './filter-search';
import 'styleguide/modules/product-filter-search';

const FILTER_NAMES = ['designer', 'size', 'color', 'condition','heel'];
const FILTERS_APPLIED_DELIMITER = "-";
let token = null;

function delayedApplication(filter) {
    clearTimeout(token);
    token = setTimeout(function () { applyFilters({filter: filter}); }, 500);
}

function bindWishList() {
    wishlist.checkWihlistTagId();
    wishlist.bindWishListEvent();
}
window.updateItemCount = updateItemCount;
window.rebindWishList = bindWishList;

$(function() {
    // We want to auto-hide the options when user clicks 'done' button.
    $('.dropdown--full').hover(function() {
        $(this).find('.dropdown__menu').show();
    }, function() {
        $(this).find('.dropdown__menu').hide();
    }).find('.filters__apply-btn').click(function() {
        $(this).closest('.dropdown__menu').hide();
    });

    FILTER_NAMES.map(function (filter) {
        getFilterInputs(filter).on('change', delayedApplication.bind(null, filter));
    });
    bindFilterAndSortBy();
    bindPaginationEvents();
    initPreNext();
    bindWishList();
    initColorSwatches();
    window.onpopstate = function(event) {
        var queryStr = location.search.startsWith("?") ? location.search.substr(1) : location.search;
        queryStr = decodeURIComponent(queryStr).replace(/\+/g, ' ');
        var queryStrArray = queryStr.split("&");
        var params = {};
        for (var i in queryStrArray) {
            if(queryStrArray[i].indexOf('=') > -1){
                var key = queryStrArray[i].substr(0, queryStrArray[i].indexOf('='));
                var value = queryStrArray[i].substr(queryStrArray[i].indexOf('=')+1);
                params[key] = value;
            }
        }
        FILTER_NAMES.map(function(filter) {
            $('input[type="checkbox"][name="' + filter + '"]').each(function(){
                var filterInput = $(this);
                var isChecked = queryStrArray.indexOf(filter + "=" + filterInput.val()) > -1;
                filterInput.prop('checked', isChecked);
            });
        });

        applyFilters(params, true);
    }

    $('.js-product-filter-search').productFilterSearch()

    if (/filters=/.test(location.search)) {  // has filter applied on page load
        FILTER_NAMES.forEach((filterName) => {
            $(`input[name="${filterName}"]`).each(function(){
                const filterInput = $(this);
                applyEnabledOrDisabledStyle(filterInput, filterInput.prop('disabled'), filterName);
            })
        });
    }
});

$(function(){
    $('.js-plp-lazy-load').plpLazyLoad({
        loadAfterCallback: function() {
            $('.js-select-size').sizeSelection();
            $('.js-plp-lazy-img').lazy({ bind: "event" });
            initColorSwatches();
            wishlist.bindWishListEvent();

            renderPlpSocialProof($('.js-plp-container').toArray().map((el) => $(el).prop('id')));
        }
    });
    $('.js-select-size').sizeSelection();
    updateLeftNavURLsOnLoad();
})

/* PLP Designer Filter - UX-18471 */
function clearPredictiveDesignerSearch() {
    // Clear the search input field
    $('.js-search-designer').val('');

    // Reset the designer list to show all designers
    $('.filters__designer-list li').each(function() {
        var span = $(this).find('span');
        var originalText = span.text();

        // Show the original text without bolding
        span.html(originalText);
        $(this).removeClass('u-hide');
    });

    // Hide the "no results" message
    $('.js-filter-search-no-results').hide().empty();

    // Uncheck all checkboxes and clear selected designers
    $('.js-enterable.checkbox__input').prop('checked', false);

    // Clear the selected designers list
    $('.selected-designers').html('');
}


function bindFilterAndSortBy() {
    $('.js-clear-filter').click(function(e) {
        const filter = $(this).data('type');
        e.preventDefault();
        getFilterInputs(filter).prop('checked', false);

        var filtersApplied = getFiltersApplied(window.location.search.substring(1));
        if (filter && filtersApplied.indexOf(filter) >= 0) {
            filtersApplied = removeFilterApplied(filtersApplied, filter);
            var url = window.location.href;
            url = filtersApplied.length ?
              replaceURLParameters(url, 'filters=' + filtersApplied) :
              removeURLParameter(url, 'filters');
            removeHash(url);
        }
        applyFilters();

        /* PLP Designer Filter - UX-18471 */
        if (filter === 'designer') {
            clearPredictiveDesignerSearch();
        }
    });

    $('.js-filter-clear-button').click(function(e) {
        $('.js-filter-empty-message').hide();
        e.preventDefault();
        clearFilters();
    });

    $('.js-sort-by').change(function(e) {
        applyFilters({ sortBy: $(this).val() });
    });

    FILTER_NAMES.map(function (filter) {
        getFilterInputs(filter).on('change', delayedApplication.bind(null, filter));
    });
}

function bindPaginationEvents(){
    var pageSizeChangeCallback = function(e) {
        let value = $(this).val();
        if($(this).is('a')){
            value = $(this).data('sortBy');
        }
        setCookie("pageSize", value, 14);
        applyFilters();
    };

    $('a.js-set-page-size').click(pageSizeChangeCallback);
    $('select.js-set-page-size').change(pageSizeChangeCallback);

    $('a.js-sort-by').click(function(e) { // wish list sort by
        e.preventDefault();
        applyFilters({ sortBy: $(this).data('sortBy') });
    });

    $('.js-pagination').click(function (e) {
        e.preventDefault();
        applyFilters({ pageNum: $(this).data('pageNum') });
    });

}
// Optional page parameter sets the pageNum.
function applyFilters(filterParams, doNotUpdateHistory) {
    var showClearButton = false;
    filterParams = filterParams || {};
    FILTER_NAMES.map(function (filter) {
        var values = getFilterValues(filter);
        if (values.length) {
            showClearButton = true;
        }
        filterParams[filter] = values;
    });

    $('.js-filter-clear-button').toggle(showClearButton);
    if(!doNotUpdateHistory){
        updateMainWindowUrl(filterParams);
    }
    appendFilterParamsToLeftNav(filterParams);
    updateContent(filterParams);
}

function keepFilters(){
    return window.rcProps && window.rcProps.keepRefineFilter;
}

function appendFilterParamsToLeftNav(filterParams){
    if(!keepFilters()){
        return;
    }
    $('.plp__sidebar li.nav-list__item a').each(function(){
        let baseUrl = clearQueryParameters($(this).attr("href"), filterParams);
        const newUrl = getUrlForParams(baseUrl, filterParams);
        $(this).attr("href", newUrl);
    });
}

function updateLeftNavURLsOnLoad(){
    if(!keepFilters()){
        return;
    }
    if($('.js-filter-clear-button').is(':visible')){
        let filterParams = {};
        FILTER_NAMES.forEach(function (filter) {
            filterParams[filter] = getFilterValues(filter);
        });
        // Might be better to just use the URL parameters but for now just getting the filter sequence
        filterParams.filter = getFiltersApplied(window.location.search.substring(1));
        appendFilterParamsToLeftNav(filterParams);
    }
}

function getQueryFromParams(params){
    return $.param(params, true);
}

function updateMainWindowUrl(params) {
    removeHash(getUrlForParams(location.pathname + clearQueryParameters(location.search, params),
        params));
}

function getUrlForParams(base, params) {
    if (params.sortBy) {
        base = clearQueryParameters(base, {featuredCodes : true});
    }
    let url = appendQuery(base, getQueryFromParams(params));
    url = clearQueryParameters(url, {filter : ''});
    if (params.filter) {
        let filtersApplied = getFiltersApplied(url);
        let filtersNotApplied = {};
        for (let filterType in params) {
            if (filterType !== "filter") {
                if (params[filterType].length > 0) {
                    filtersApplied = addFilterApplied(filtersApplied, filterType);
                } else {
                    filtersNotApplied[filterType] = true;
                }
            }
        }
        for (let filterType in filtersNotApplied) {
            filtersApplied = removeFilterApplied(filtersApplied, filterType);
        }
        url = filtersApplied ?
          replaceURLParameters(url, 'filters=' + filtersApplied) :
          clearQueryParameters(url, {filters: ''})
    }
    return url;
}

// Inspired by https://stackoverflow.com/a/3855394
function getFiltersApplied(fullQueryString) {
    if (fullQueryString) {
        var qs = fullQueryString.split('&');
        if (qs) {
            for (var i = 0; i < qs.length; ++i) {
                var p = qs[i].split('=', 2);
                if (p[0] === 'filters') {
                    if (p.length == 1)
                        return '';
                    else
                        return decodeURIComponent(p[1].replace(/\+/g, " ")).replace(/^=/, "");
                }
            }
        }
    }
    return '';
}

// https://stackoverflow.com/a/5298684
function removeHash (url) {
    var scrollV, scrollH, loc = window.location;
    if ("pushState" in history) {
        var urlWithoutHash = url ? url.replace('#', '') : loc.pathname + loc.search; // Last ditch effort to remove hash
        history.pushState("", document.title, urlWithoutHash);
    } else {
        // Prevent scrolling by storing the page's current scroll offset
        scrollV = document.body.scrollTop;
        scrollH = document.body.scrollLeft;

        loc.hash = "";

        // Restore the scroll offset, should be flicker free
        document.body.scrollTop = scrollV;
        document.body.scrollLeft = scrollH;
    }
}

function bindViewMoreButtonEvents() {
    $('.js-toggle-reveal').toggleReveal();
}

/* jQuery's jqXHR doesn't *quite* cancel properly. So we encapsulate it here
 * and make sure old requests get properly disposed of.
 */
function ContentUpdate($container, url) {
    var canceled = false;

    this.go = function() {
        $container.css('opacity', '0.5');
        $.ajax(url, {
            success: success
        });
        return this;
    };

    this.cancel = function() {
        canceled = true;
    };

    function success(data) {
        if (!canceled) {
            $('#plp-product-list').html($('#plp-product-list', $(data)).html());
            $('#plp-product-list div').first().css('min-height','');
            $('#plp-header .js-dropdown').dropdown();
            $('#plp-header .js-filter-clear-button').click(function(e){
                e.preventDefault();
                FILTER_NAMES.map(function(filter) {
                    getFilterInputs(filter).prop('checked', false);
                });
                applyFilters();
            });
            $('#cur-sortby').html($('#cur-sortby', $(data)).html());
            $('#cur-pageview').html($('#cur-pageview', $(data)).html());
            wishlist.updateItemCount(data);
            // $container.html(data);
            $('html, body').animate({ scrollTop: 0 }, 0);
            $container.animate({ opacity: 1 }, 200);
            $(window).trigger('content-load');
            dynamicallyDisableFilters();
            bindPaginationEvents();
            initPreNext();
            wishlist.bindWishListEvent();
            bindViewMoreButtonEvents();
            $('.js-select-size').sizeSelection();
            if (typeof window.insertPageTrackForMultiItemQuickView === "function") {
                window.insertPageTrackForMultiItemQuickView(url);
            }
            renderPlpSocialProof($('.js-plp-container').toArray().map((el) => $(el).prop('id')));
        }
        else {
            console.log("cancelled: " + url);
        }
    }
}

var updateContent = (function() {
    var pending = null;
    return function(params) {
        if (pending) {
            pending.cancel();
            pending = null;
        }
        var $container = $('#productsList');
        var url = $container.data('base-url');
        url = clearQueryParameters(url, params);
        url = replaceURLParameters(url, getQuery(window.location.href));
        pending = new ContentUpdate($container, url).go();
        return pending;
    };
}());

function setCookie(c_name, value, exdays) {
    var exdate = new Date();
    exdate.setDate(exdate.getDate() + exdays);
    var c_value = escape(value) + ((exdays == null) ? "" : "; expires=" + exdate.toUTCString());
    document.cookie = c_name + "=" + c_value + "; path=/";
}

function updateItemCount(numItems) {
    $('.js-item-count').html(numItems.toLocaleString());
    removeMsgNoProducts(numItems);
}

function removeMsgNoProducts(numItems) {
    if (numItems === 0) {
        $('.js-filter-empty-message').show();
        $('#resetFilterMsgBtn').show();
    } else {
        $('.js-filter-empty-message').hide();
        $('#resetFilterMsgBtn').hide();
    }
}

function addFilterApplied(filtersAppliedDelimited, filterToAdd) {
    let result;

    if (filtersAppliedDelimited) {
        result = filtersAppliedDelimited.indexOf(filterToAdd) >= 0 ?
          filtersAppliedDelimited :
          filtersAppliedDelimited + FILTERS_APPLIED_DELIMITER + filterToAdd;
    } else {
        result = filterToAdd;
    }

    return result;
}

function removeFilterApplied(filtersAppliedDelimited, filterToRemove) {
    // /-{1}filter|filter{1}-|filter/g
    return filtersAppliedDelimited.replaceAll(new RegExp('-{1}' + filterToRemove + '|' + filterToRemove + '-{1}|' + filterToRemove, 'g'), '');
}

function clearFilters() {
    FILTER_NAMES.map(function(filter) {
        getFilterInputs(filter).prop('checked', false);
    });

    clearPredictiveDesignerSearch();
    removeHash(removeURLParameter(window.location.href, 'filters'));
    applyFilters();
}

// Using a wrapper function for now, in case I want to separate functions later.
function setPageNumber(page) {
    applyFilters({ pageNum: page });
}

function clearFilterFromURL(url, filter){
    return removeURLParameter(url, filter);
}

function getFilterValues(filter){
    let values = [];
    let checked = getFilterInputs(filter).filter(':checked');
    let $div = $('<div/>');
    checked.each(function(i, element) {
        values.push($div.html($(element).attr('value')).text()); // Basically decode & trim...?
    });
    let numChecked = checked.length;
    $('.filters__count-' + filter).html((numChecked > 0) ? "(" + numChecked + ")" : "");
    return values;
}

function getFilterInputs(filter) {
    return $('input[type="checkbox"][name="' + filter + '"]');
}

function clearQueryParameters(url, params) {
    for (var p in params) {
        url = removeURLParameter(url, p);
    }

    return url;
}

function getQuery(url) {
    return (url.indexOf("?") > -1) ? url.substring(url.indexOf("?") + 1) : "";
}

function appendQuery(url, query) {
    if ("" == query) {
        return url;
    }
    query = $('<div/>').html(query).text();
    return url + ((url.indexOf("?") > -1) ? "&" : "?") + query;
}

// http://stackoverflow.com/a/1634841
function removeURLParameter(url, parameter) {
    //prefer to use l.search if you have a location/link object
    var urlparts= url.split('?');
    if (urlparts.length>=2) {

        var encodedPrefix= encodeURIComponent(parameter)+'=';
        var unencodedPrefix = parameter + '=';
        var pars= urlparts[1].split(/[&;]/g);

        //reverse iteration as may be destructive
        for (var i= pars.length; i-- > 0;) {
            //idiom for string.startsWith
            if (pars[i].lastIndexOf(encodedPrefix, 0) !== -1) {
                pars.splice(i, 1);
            }
            else if (pars[i].lastIndexOf(unencodedPrefix, 0) !== -1) {
                pars.splice(i, 1);
            }
        }

        url= urlparts[0] + (pars.length > 0 ? '?' + pars.join('&') : "");
        return url;
    } else {
        return url;
    }
}

// Safe concatenation of url and param strings with taking care of '?' and '&' characters
function safeConcat(url, paramString) {

    var result = '';

    // get rid of the leading '?' or '&' characters
    paramString = removeLeadingChars(paramString);

    var endsWithAmpOrQuestion = /[\?&]$/;

    if(url.indexOf('?') > -1) {
        if (url.match(endsWithAmpOrQuestion)) {
            result = url + paramString;
        } else {
            result = url + '&' + paramString;
        }
    } else {
        result = url + '?' + paramString;
    }

    return result;
}

// Remove the leading '?' or '&' characters
function removeLeadingChars(paramString) {
    // remove RegExp
    var re = /^[?&]+/;
    return paramString.replace(re, '');
}

// Replace existing parameters in url with new values in parameterString
function replaceURLParameters(url, parameterString){
    if (!parameterString)
        return url;

    var parameters = parameterString.split('&');
    var rtn = url;
    var tmp='';
    if (parameters) {
        for (var i=0; i<parameters.length; i++) {
            var p = parameters[i];
            if (p){
                var parameterPair = p.split('=');
                if (parameterPair && parameterPair.length == 2){
                    rtn = removeURLParameter(rtn, parameterPair[0]);
                }
                tmp = appendQuery(tmp, p);
            }
        }

        rtn = safeConcat(rtn, tmp);
    }
    return rtn;
}

function initPreNext(){
    if(window.localStorage){
        var data = $("#product-code-div").data("productList");
        var maxListSize = 20;
        if(data){
            var listIndex = window.localStorage.getItem("current-index");
            if(!listIndex) listIndex = 0;
            var index = (parseInt(listIndex) + 1 ) % maxListSize;
            var newKey = "plp-list-" + index;

            window.localStorage.setItem("current-index", index);
            window.localStorage.setItem(newKey, data);
            $(".product__link").click(function(event){
                var url = $(this).attr("href");
                if(url.indexOf("?") == -1){
                    url += "?list=" + newKey;
                }else{
                    url += "&list=" + newKey;
                }
                url = url.replace(/\?&+/g, "?").replace(/&+/g, "&"); // remove extra & in the url
                $(this).attr("href", url);
            });
        }
    }
}

function dynamicallyDisableFilters(){
    var data = $.param({
        url: window.location.href
    });

    $.ajax({
        url: '/fw/content/products/applicable-filters/',
        data: data,
        dataType: 'json',
        type: 'GET',
        success: function(rtn){
            if (rtn && rtn.filters){
                for (var filterType in rtn.filters) {
                    if (rtn.filters.hasOwnProperty(filterType)) {
                        var obj = rtn.filters[filterType];
                        if ($.isPlainObject(obj)) { // extra level since they're grouped (i.e., sizes)
                            for (var filterKey in obj) {
                                if (obj.hasOwnProperty(filterKey)) {
                                    var filterList = obj[filterKey];
                                    for (var k = 0; k < filterList.length; k++) {
                                        enableOrDisableFilter(filterList[k]);
                                    }
                                }
                            }
                        } else {
                            for (var j = 0; j < obj.length; j++) {
                                enableOrDisableFilter(obj[j]);
                            }
                        }
                    }
                }
            }
        }
    });
}

function applyEnabledOrDisabledStyle(filter, disabled, category) {
    if (filter) {
        filter.prop('disabled', disabled);
        const siblings = filter.siblings('label');
        const label = siblings && siblings.length > 0
            ? $(siblings[0])
            // check if the input is a child of a label (initially for an AB test of designer search)
            : filter.parent('label');
        if (label) {
            const cssClass = category === "sustainability"
                ? "sustainable__filter--disabled"
                : "filters__size--disabled";
            if (disabled) {
                label.addClass(cssClass);
                label.attr('aria-disabled', 'true')
            } else {
                label.removeClass(cssClass);
                label.attr('aria-disabled', 'false')
            }
        }

        //if somehow the filter was chosen, deselect it, this will trigger another AJAX fetch of the product set
        //ideally these should have already been removed before we get here
        if (disabled && filter.prop("checked")) {
            filter.prop("checked", false);
            filter.trigger("change");
        }
    }
}

window.enableOrDisableFilter = function(filterObj){
    if (filterObj) {
        const filter = $('#' + filterObj.idForHTML);
        if (filter) {
            applyEnabledOrDisabledStyle(filter, filterObj.disabled, filterObj.category);
        }
    }
};



// WEBPACK FOOTER //
// ./src/scripts/entry-points/plp/index.js